import _ from 'underscore'
import Backbone from 'backbone'
import HomeViewTemplate from '../templates/home.tpl'
import TitleView from './title'
import HeaderView from './header'
import NavView from './nav'
import UnlockBannerView from './unlock-banner'
import titles from '../titles'
import config from '../config'
import user from '../user'

const HomeView = Backbone.View.extend({
    el: '#current-view',

    events: {
        'keyup #search-input': 'onSearch'
    },

    initialize() {
        this.template = _.template(HomeViewTemplate)

        // Create and store a reference to the bound scroll handler
        this._scrollHandler = this.scrollRemember.bind(this)

        // Property to store the current search query
        this.searchQuery = ''

        // Listen for changes in the titles collection:
        this.listenTo(titles, 'reset update change', this.renderTitles)
    },

    render() {
        // Render the base template once: header, nav, empty #menu-view
        this.$el.html(this.template())

        // Add the header and nav subviews
        const headerView = new HeaderView()
        this.$('#header-view').append(headerView.render().el)

        const navView = new NavView()
        this.$('#nav-view').append(navView.render().el)

        // Now render the titles list
        this.renderTitles()

        // Listen for scroll events to save the scroll position
        this.$('#menu-view').on('scroll', this._scrollHandler)

        return this
    },

    onSearch(e) {
        this.searchQuery = e.target.value.trim().toLowerCase();
        this.renderTitles();
    },

    scrollRemember() {
        const scrollTop = this.$('#menu-view').scrollTop()
        const slug = config.get('slug')
        let scrollPositions = config.get('scrollPositions') || {}
        scrollPositions[slug] = scrollTop
        config.set('scrollPositions', scrollPositions)
    },

    /**
     * Renders (or re-renders) the titles list inside #menu-view
     * whenever the collection changes
     */
    renderTitles() {
        const $menu = this.$('#menu-view')
        const slug = config.get('slug')
        const appId = config.get('id')
        const scrollPos = (config.get('scrollPositions') || {})[slug] || 0;

        // reset the title list
        $menu.empty()

        // check if the user has purchased the app
        const hasPurchased = user.get('purchased').purchased(appId)

        // filter based on the search
        const filtered = titles.filter(title => {
            return !this.searchQuery ||
                title.get('name').toLowerCase().includes(this.searchQuery)
        })

        // split the filtered titles by free and paid
        const freeTitles = filtered.filter(title => title.get('free'))
        const paidTitles = filtered.filter(title => !title.get('free'))

        // render the free titles
        freeTitles.forEach(title => {
            $menu.append(new TitleView({ model: title}).render().el)
        })

        // if there is no paid titles due to the search hide this
        // also hide if it has been purchased
        if (paidTitles.length > 0 && !hasPurchased) {
            $menu.append(new UnlockBannerView().render().el)
        }

        // render the paid titles
        paidTitles.forEach(t => {
            $menu.append(
                new TitleView({
                    model:  t,
                    locked: !hasPurchased
                }).render().el
            )
        })

        // set the scroll position
        $menu.scrollTop(scrollPos)
    },

    // Override undelegateEvents to remove the manual scroll binding
    undelegateEvents() {
        if (this.$el && this.$el.length) {
            const $menuView = this.$('#menu-view');
            if ($menuView && $menuView.length) {
                $menuView.off('scroll', this._scrollHandler);
            }
        }
        return Backbone.View.prototype.undelegateEvents.call(this);
    }
})

export default HomeView
